import { useState } from 'react';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function IdentityScreen({ onContinue }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [touched, setTouched] = useState({ name: false, email: false });

  const trimmedName = name.trim();
  const trimmedEmail = email.trim();
  const nameValid = trimmedName.length > 0;
  const emailValid = EMAIL_RE.test(trimmedEmail);
  const formValid = nameValid && emailValid;

  const submit = (e) => {
    e.preventDefault();
    if (!formValid) {
      setTouched({ name: true, email: true });
      return;
    }
    onContinue({ full_name: trimmedName, email: trimmedEmail });
  };

  return (
    <form onSubmit={submit} className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-900">Connection test</h1>
        <p className="mt-2 text-slate-600">
          Before we begin, we need your name and email so the recruiter can match this run to your application.
        </p>
      </div>

      <div className="space-y-4">
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Full name</span>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            onBlur={() => setTouched(t => ({ ...t, name: true }))}
            autoComplete="name"
            className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2 shadow-sm focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500"
          />
          {touched.name && !nameValid ? (
            <p className="mt-1 text-sm text-red-600">Please enter your full name.</p>
          ) : null}
        </label>

        <label className="block">
          <span className="text-sm font-medium text-slate-700">Email</span>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onBlur={() => setTouched(t => ({ ...t, email: true }))}
            autoComplete="email"
            className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2 shadow-sm focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500"
          />
          {touched.email && !emailValid ? (
            <p className="mt-1 text-sm text-red-600">Please enter a valid email address.</p>
          ) : null}
        </label>
      </div>

      <button
        type="submit"
        disabled={!formValid}
        className="rounded-md bg-slate-900 px-4 py-2 text-white shadow hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-500 disabled:cursor-not-allowed disabled:opacity-50"
      >
        Continue
      </button>
    </form>
  );
}
